<div>
    <Navbar />
    <Sidebar />

    <div class="page-wrapper">
      <div class="hero-section w-100">
        <div class="border rounded-4 p-2 custom-border">
          <!-- KPI cards -->
          <div class="row text-center mb-3">
            <div class="col-md-4 mb-3">
              <div class="card rounded-4 shadow-sm users-card">
                <div class="card-body">
                  <p class="card-text display-5">{{ total_organizations }}</p>
                  <h5 class="card-title">Total Organizations</h5>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="card rounded-4 shadow-sm users-card">
                <div class="card-body">
                  <p class="card-text display-5">{{ active_organizations }}</p>
                  <h5 class="card-title">Active Organizations</h5>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="card rounded-4 shadow-sm users-card">
                <div class="card-body">
                  <p class="card-text display-5">{{ inactive_organizations }}</p>
                  <h5 class="card-title">Inactive Organization</h5>
                </div>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="card table-card">
            <div class="card-body">
              <div class="table-responsive content-table">
                <div v-if="org_loading" class="text-center py-4">Loading organizations…</div>
                <div v-else-if="!organizations.length" class="text-center py-4">No organizations found</div>

                <table
                  id="control_table"
                  ref="orgTable"
                  class="table text-xs table-striped"
                  data-sort="true"
                  v-show="!org_loading && organizations.length"
                >
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Company Name</th>
                      <th>Registration Number</th>
                      <th>Company Address</th>
                      <th>Enabled Platform(s)</th>
                      <th>Revoked Platform(s)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody class="text-start text-xs">
                    <tr v-for="(org, index) in organizations" :key="org.id || index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ org.name }}</td>
                      <td>{{ org.registration }}</td>
                      <td>{{ org.address }}</td>
                      <td>{{ org.enabled_count }}</td>
                      <td>{{ org.revoked_count }}</td>
                      <td>
                        <div class="d-flex gap-2">
                          <button class="btn btn-sm upload-button" @click="open_manage_modal(org)">
                            Manage
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Manage Platforms Modal -->
    <div class="modal fade" id="managePlatformsModal" tabindex="-1" aria-labelledby="managePlatformsLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title gradient-text" id="managePlatformsLabel">
              Manage Platforms <small v-if="selected_org">for {{ selected_org.name }}</small>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    @click="clear_platform_selection"></button>
          </div>

          <div class="modal-body">
            <!-- loader -->
            <div v-if="platforms_loading" class="text-center py-4">
              <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
              <p class="mt-2">Fetching platforms…</p>
            </div>

            <!-- empty -->
            <div v-else-if="!platforms.length" class="text-center py-4">
              No platforms found.
            </div>

            <!-- selection toolbar -->
            <div v-else class="mb-3 d-flex flex-wrap align-items-center gap-2">
              <span class="badge bg-secondary">Selected: {{ selected_platform_ids.length }}</span>
              <button class="btn btn-sm btn-outline-secondary" @click="select_all_platforms">Select all</button>
              <button class="btn btn-sm btn-outline-secondary" @click="clear_platform_selection">Clear</button>

              <div class="ms-auto d-flex gap-2">
                <button class="btn btn-sm upload-button"
                        :disabled="!selected_platform_ids.length || bulk_loading"
                        @click="bulk_set_platform_access('ENABLE')">
                  <span v-if="bulk_loading" class="spinner-border spinner-border-sm me-1"></span>
                  Enable Selected
                </button>
                <button class="btn btn-sm btn-outline-danger"
                        :disabled="!selected_platform_ids.length || bulk_loading"
                        @click="bulk_set_platform_access('REVOKE', true)">
                  <span v-if="bulk_loading" class="spinner-border spinner-border-sm me-1"></span>
                  Revoke Selected
                </button>
              </div>
            </div>

            <!-- 2-2-2 grid -->
            <div class="row row-cols-2 g-3" v-if="platforms.length">
              <div class="col" v-for="p in platforms" :key="p.id">
                <div class="card h-100 shadow-sm">
                  <div class="card-body d-flex flex-column">
                    <div class="d-flex align-items-center gap-2 mb-2">
                      <input class="form-check-input mt-0"
                             type="checkbox"
                             :value="p.id"
                             :checked="selected_platform_ids.includes(p.id)"
                             @change="toggle_select_platform(p.id)" />
                      <h6 class="mb-0">{{ p.name }}</h6>
                    </div>

                    <div class="mt-auto d-flex gap-2">
                      <button class="btn btn-sm upload-button flex-fill"
                              :disabled="bulk_loading"
                              @click="single_set_platform_access('ENABLE', p.id)">
                        Enable
                      </button>
                      <button class="btn btn-sm btn-outline-danger flex-fill"
                              :disabled="bulk_loading"
                              @click="single_set_platform_access('REVOKE', p.id)">
                        Revoke
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div><!-- /modal-body -->

          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal" :disabled="bulk_loading">
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
</div>